import {
  inboundShipmentIdFormat,
  inboundShipmentProductIdFormat,
  productIdFormat,
  shipmentDisputeIdFormat,
  supplierIdFormat,
} from "@redotech/redo-model/ids";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { DisputeStatus } from "./dispute-status";

const DisputePhotoSchema_ = z.object({
  url: z.string(),
  contentType: z.string(),
});

export const DisputePhotoSchema: z.ZodType<DisputePhoto> = DisputePhotoSchema_;
export interface DisputePhoto extends z.infer<typeof DisputePhotoSchema_> {}

const DisputeListItemSchema_ = z.object({
  id: shipmentDisputeIdFormat.schema,
  inboundShipmentProductId: inboundShipmentProductIdFormat.schema,
  status: createEnum(DisputeStatus),
  supplierEmail: z.string(),
  emailSubject: z.string(),
  emailBody: z.string(),
  damagedQuantity: z.number(),
  missingQuantity: z.number(),
  unitCost: z.number(),
  costCurrency: z.string(),
  sentAt: zExt.instant().nullable(),
  createdAt: zExt.instant(),
  // Joined data
  productId: productIdFormat.schema,
  productSku: z.string().nullable(),
  productTitle: z.string(),
  shipmentId: inboundShipmentIdFormat.schema,
  shipmentNumber: z.string().nullable(),
  supplierId: supplierIdFormat.schema.nullable(),
  supplierName: z.string().nullable(),
  photos: z.array(DisputePhotoSchema),
});

export const DisputeListItemSchema: z.ZodType<DisputeListItem> =
  DisputeListItemSchema_;
export interface DisputeListItem
  extends z.infer<typeof DisputeListItemSchema_> {}

export const getDisputes = {
  name: "getDisputes" as const,
  input: z.object({}),
  output: z.object({ disputes: z.array(DisputeListItemSchema) }),
};
